import { Component, OnInit } from '@angular/core';
import {ExcRestService} from 'exc-rest';
import {ExcCoreModule, ExcTranslation} from 'exc-core';
import {IExcTab} from 'exc-tab';
import {ExcListConfig} from 'exc-controls';
import {ExcProgbarData} from '../app-exc-progbar/app-exc-progbar.component';
import {ModalInfoMailComponent} from '../modals/modal-info-mail/modal-info-mail.component';
import {ExcIndicatorData} from '../app-exc-indicator/app-exc-indicator.component';
import {DefaultSettingsService} from '../default-settings-service.service';

@Component({
  selector: 'app-order-details',
  templateUrl: './order-details.component.html',
  styles: []
})
export class OrderDetailsComponent extends ExcTranslation implements OnInit, IExcTab {

  Data: any;
  order: {Header: {}, Activities: [], Persons: [], Documents: []};
  tabinstance: any;
  activitylistconfig: ExcListConfig = new ExcListConfig();
  documentlistconfig: ExcListConfig = new ExcListConfig();
  personlistconfig: ExcListConfig = new ExcListConfig();
  progbarBalanceParts: ExcProgbarData[] = [];
  progbarCurrentBalance: ExcProgbarData[] = [];
  indicatorData: ExcIndicatorData[] = [];
  totalClaims = 0;
  searchValue: string = null;
  constructor(private excRest: ExcRestService,private excDss: DefaultSettingsService) {
    super();
    this.order = {Header: {}, Activities: [], Persons: [], Documents: []};
    const _self = this;
    _self.personlistconfig.selectionMode = 'none';
    _self.documentlistconfig.selectionMode = 'none';
    _self.activitylistconfig.selectionMode = 'none';
    _self.activitylistconfig.paging = {pagingTotalRows: 1, pagingTotalPages: 1, pagingPage: 1, pagingPageSize: 10};
    _self.activitylistconfig.OnSearch = function (searchValue, event?) {
      _self.searchValue = searchValue || '';
      _self.reloadActivities();
    };
    _self.activitylistconfig.OnPageChanged = (pageNo, event1) => {
      _self.activitylistconfig.paging.pagingPage = pageNo;
      _self.reloadActivities();
    };
    _self.activitylistconfig.OnRefresh = () => {
      _self.reloadActivities();
    };
  }

  ngOnInit() {
    this.initialLoad();
  }

  requestInfo() {
    ExcCoreModule.showModal(ModalInfoMailComponent,  null, 'l', this.Data, false, null).subscribe(response => {
      if (response.proceed === true) {
        const url = this.excRest.computeUrl('OrderU_RequestInfo', {OrderID: this.Data.OrdId});
        this.excRest.post(url, {Subject: response.subject, Body: response.body}
          , null).subscribe(e => {
        });
      }
    });
  }

  downloadItem(data) {
    const url = this.excRest.computeUrl('DocumentR_Download', {DocumentID: data.ActID});
    window.location.href = url;
  }

  getFileIcon(data) {
    switch (data.Filetype) {
      case 'PDF':
        return 'fa-file-pdf';
      case 'XLS':
      case 'XLSX':
        return 'fa-file-excel';
      case 'DOC':
      case 'DOCX':
        return 'fa-file-word';
    }
    return 'fa-image';
  }
  getFileTooltip(data) {
    switch (data.Filetype) {
      case 'PDF':
        return this.getGlobal('Download_Pdf');
      case 'XLS':
      case 'XLSX':
        return this.getGlobal('Download_Excel');
      case 'DOC':
      case 'DOCX':
        return this.getGlobal('Download_Word');
    }
    return this.getGlobal('Download_Image');;
  }
  reloadActivities() {
    const _self = this;
    const url = _self.excRest.computeUrl('OrderActivityR_List', {OrderID: this.Data.OrdId, fts: this.searchValue == null ? '' : this.searchValue});
    const mi = this.activitylistconfig.GetMetaInfo();
    _self.activitylistconfig.isLoading = true;
    _self.excRest.get(url, {MetaInfo: mi}).subscribe(ret => {
      if (ret) {
        _self.order.Activities = ret.data;
        _self.activitylistconfig.paging = ret.paging;
        _self.activitylistconfig.isLoading = false;
      }
    });
  }
  initialLoad () {
    const _self = this;
    const url = _self.excRest.computeUrl('OrderR_Summary', {OrderID: this.Data.OrdId});
    const mi = this.activitylistconfig.GetMetaInfo();
    _self.activitylistconfig.isLoading = true;
    _self.documentlistconfig.isLoading = true;
    _self.personlistconfig.isLoading = true;
    _self.excRest.get(url, {MetaInfo: mi}).subscribe(ret => {
      if (ret) {
        _self.order.Activities = ret.data.Activities;
        _self.order.Header = ret.data.Header;
        _self.order.Persons = ret.data.Persons;
        _self.order.Documents = [];
        for (const x of _self.order.Activities) {
          if (x['Filetype'] !== null) {
            _self.order.Documents.push(x);
          }
        }

        _self.progbarCurrentBalance = [];
        _self.progbarBalanceParts = [];
        _self.progbarCurrentBalance.push(new ExcProgbarData(_self.order.Header['OrdAktKontostand'], _self.getGlobal('CurrentBalance')
              ,  (_self.order.Header['OrdAktKontostand'] <= 0 ? 'rgba(92, 184, 92, 0.6)' : 'rgba(201, 48, 44, 0.6)')
              , '#fff'   ));

        _self.progbarBalanceParts.push(new ExcProgbarData(_self.order.Header['OrdForderungAuftragserteilung'], _self.getGlobal('Forderung')
          ,  'rgba(244, 147, 6, 0.6)'
          , '#fff'   ));
        _self.progbarBalanceParts.push(new ExcProgbarData(_self.order.Header['OrdRateZinsenGebuehr'], _self.getGlobal('RateGebuehr')
          ,  'rgba(32, 83, 148, 0.6)'
          , '#fff'   ));
        _self.progbarBalanceParts.push(new ExcProgbarData(_self.order.Header['OrdRealisierteZahlung'], _self.getGlobal('RealizedPayments')
          , 'rgba(92, 184, 92, 0.6)'
          , '#fff'   ));


        _self.indicatorData = [];

        _self.totalClaims = Math.abs(_self.order.Header['OrdAktKontostand']) + Math.abs(_self.order.Header['OrdRealisierteZahlung']);

        _self.indicatorData.push(new ExcIndicatorData(_self.order.Header['OrdForderungAuftragserteilung'],
          _self.getGlobal('Forderung'), _self.getGlobal('Forderung')
          ,  'rgba(244, 147, 6, 0.6)'
         , false   ));
        _self.indicatorData.push(new ExcIndicatorData(_self.order.Header['OrdRateZinsenGebuehr'],
          _self.getGlobal('RateGebuehr'), _self.getGlobal('RateGebuehr')
          ,  'rgba(32, 83, 148, 0.6)'
        , false   ));
        _self.indicatorData.push(new ExcIndicatorData(_self.order.Header['OrdRealisierteZahlung'],
          _self.getGlobal('RealizedPayments'), _self.getGlobal('RealizedPayments')
          , 'rgba(92, 184, 92, 0.6)'
         , false ));
        _self.indicatorData.push(new ExcIndicatorData(_self.order.Header['OrdAktKontostand'],
          _self.getGlobal('CurrentBalance'), _self.getGlobal('CurrentBalance')
          ,  (_self.order.Header['OrdAktKontostand'] <= 0 ? 'rgba(92, 184, 92, 0.6)' : 'rgba(201, 48, 44, 0.6)')
          , true  ));

        _self.activitylistconfig.paging = ret.paging.Activities;
        _self.documentlistconfig.isLoading = false;
        _self.personlistconfig.isLoading = false;
        _self.activitylistconfig.isLoading = false;
      }
    });
  }

}
